import React from 'react';
import PropTypes from 'prop-types';
import './svg.css';


const SupportIcon = props => {
  const { fill, className } = props;
  return (
    <svg
      viewBox="3 -3 10 20"
      height="18px"
      width="18px"
      // className='svg'
    >
      <path d="M2.875,17.75 C2.63541667,17.75 2.39583333,17.6541667 2.20416667,17.4625 L0.2875,15.5458333 C-0.0958333333,15.1625 -0.0958333333,14.5875 0.2875,14.2041667 C0.670833333,13.8208333 1.29375,13.8208333 1.62916667,14.2041667 L2.875,15.45 L6.0375,12.2875 C6.42083333,11.9041667 6.99583333,11.9041667 7.37916667,12.2875 C7.7625,12.6708333 7.7625,13.2458333 7.37916667,13.6291667 L3.54583333,17.4625 C3.35416667,17.6541667 3.11458333,17.75 2.875,17.75 Z" id="check" fillRule="nonzero"></path>
      <path d="M17,-3.55271368e-15 C18.6568542,-3.85707287e-15 20,1.34314575 20,3 L20,12.01 L20.0249378,12 L20.0249378,16.5857864 C20.0249378,17.1380712 19.5772226,17.5857864 19.0249378,17.5857864 C18.7597213,17.5857864 18.5053674,17.4804296 18.317831,17.2928932 L16.025,15 L10.983625,15.0004142 C10.7265344,11.0912025 7.47426172,8 3.5,8 C2.23566068,8 1.04439234,8.31285407 -0.000613975575,8.86537118 L0,3 C-2.02906125e-16,1.34314575 1.34314575,-3.24835449e-15 3,-3.55271368e-15 L17,-3.55271368e-15 Z M13,4 L4,4 C3.44771525,4 3,4.44771525 3,5 C3,5.55228475 3.44771525,6 4,6 L4,6 L13,6 C13.5522847,6 14,5.55228475 14,5 C14,4.44771525 13.5522847,4 13,4 L13,4 Z" id="Combined-Shape" fill={fill ? fill : "#000"}></path>
    </svg>
  );
};

// SupportIcon.propTypes = {
//   active: PropTypes.bool.isRequired,
//   label: PropTypes.bool.isRequired,
// };

export default SupportIcon;
